export default __webpack_public_path__ + "2770e32f9b5a807c295a31c11aefbfdd.svg";